export enum EModeleAppareilSurface {
    BiocontactL6 = 1,
    Biocontact99,
}